import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react";
import { Button, useVeriToast } from "@verivest/shared-components";
import useInvestmentModel from "@verivest/shared-components/src/api/hooks/models/useInvestmentModel/useInvestmentModel";
import { useStandardApiHandler } from "@verivest/shared-components/src/error-handling/useStandardApiErrorHandler";
import React from "react";

interface CancelInvestmentModalProps {
  investmentId: string;
  onClose: () => void;
  isOpen: boolean;
}
export const CancelInvestmentModal = ({
  investmentId,
  onClose,
  isOpen,
}: CancelInvestmentModalProps) => {
  const { toastSuccess } = useVeriToast();
  const investmentModel = useInvestmentModel();

  const { isLoading, wrapApiRequest } = useStandardApiHandler();

  const onDelete = wrapApiRequest(async () => {
    await investmentModel.deleteRecord(investmentId);
    toastSuccess("Investment deleted");
    onClose();
  });

  return (
    <Modal size="xl" isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius={"2px"}>
        <Box px={8} pt={8}>
          <ModalCloseButton position="static" />
        </Box>
        <ModalHeader px={8}>Cancel investment?</ModalHeader>
        <ModalBody px={8}>
          <Box textStyle="bodyRegular" mb="16px">
            By cancelling, this investment will be removed from your
            &quot;Pending Investments&quot;. Should you change your mind after
            cancelling, you will need to re-complete the investment process.
          </Box>
          <Box textStyle="bodyRegular">
            Do you wish to cancel this investment?
          </Box>
        </ModalBody>
        <ModalFooter justifyContent="start" p={8}>
          <Stack direction="row">
            <Button
              px="24px"
              py="12px"
              onClick={onDelete}
              isLoading={isLoading}
            >
              Confirm
            </Button>
            <Button isBold px="24px" py="12px" outline onClick={onClose}>
              Go back
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
